import { render } from "./FinishesView.vue?vue&type=template&id=2c26cc48&scoped=true"
import script from "./FinishesView.vue?vue&type=script&lang=js"
export * from "./FinishesView.vue?vue&type=script&lang=js"

import "./FinishesView.vue?vue&type=style&index=0&id=2c26cc48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c26cc48"]])

export default __exports__